"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useImageInfo;
var _react = require("react");
var _editor = require("../../utilities/editor");
var _utilities = require("../../utilities");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * CALIBRATION_DATA_VGPB
 * THERMAL_IMAGER_INFO_DATA_GPB
 * THERMAL_IMAGE_INFO_DATA_VGPB
 * VL_IMAGE_METADATA_VGPB
 * MARKERS
 * IRVIEWER
 */
function useImageInfo() {
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    imageInfo = _useState2[0],
    setImageInfo = _useState2[1];
  var arePropsEqual = function arePropsEqual(prevProp, nextProp) {
    // Simplify the first condition
    if (prevProp === nextProp || nextProp == null || Number.isNaN(nextProp)) {
      return true;
    }

    // Check Objects
    if (_typeof(nextProp) === "object" && !Array.isArray(nextProp)) {
      if ((prevProp === null || prevProp === void 0 ? void 0 : prevProp.code) === nextProp.code || (prevProp === null || prevProp === void 0 ? void 0 : prevProp.description) === nextProp.description) {
        return true;
      }
    }

    // Check Arrays
    if (Array.isArray(nextProp)) {
      // From null to array
      if (!Array.isArray(prevProp)) {
        return false;
      }

      // Lengths don't match
      if (nextProp.length !== prevProp.length) {
        return false;
      }

      // Lengths match but contents have changed
      var _iterator = _createForOfIteratorHelper(nextProp.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            index = _step$value[0],
            nextNote = _step$value[1];
          var prevNote = prevProp[index];
          if (prevNote !== null && (nextNote.id !== prevNote.id || nextNote.date !== prevNote.date)) {
            // Return early after the first occurrence
            return false;
          }
        }

        // No differences found in array contents
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true;
    }
    return false;
  };
  var checkBasicPresentationFlags = (0, _react.useCallback)(function () {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var keys = ["irAlphaLevel", "pipMode"];
    var vgpb = imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.THERMAL_IMAGE_INFO_DATA_VGPB;
    var basicPresentationFlags = vgpb === null || vgpb === void 0 ? void 0 : vgpb.basicPresentationFlags;
    var nextProps = {};
    keys.forEach(function (key) {
      if (key in settings) {
        nextProps[key] = settings[key];
        if (key === "pipMode") {
          nextProps.pipMode = (0, _editor.boolToPip)(nextProps.pipMode);
        }
        if (key === "irAlphaLevel") {
          nextProps.irAlphaLevel = (0, _editor.normalizedToFusion)(nextProps.irAlphaLevel);
        }
      }
    });

    // IMPORTANT - prevents re-renders
    var updatedProps = {};
    for (var key in nextProps) {
      var value = nextProps[key];
      var isEqual = arePropsEqual(basicPresentationFlags[key], value);
      if (isEqual === false) updatedProps[key] = value;
    }
    return updatedProps;
  }, [imageInfo]);
  var checkIRPaletteSetup = (0, _react.useCallback)(function () {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var keys = ["irOrientation", "paletteScheme", "paletteScaleMode", "backgroundTemp", "paletteRangeMinTempC", "paletteRangeMaxTempC"];
    var nextProps = {};
    keys.forEach(function (key) {
      if (key in settings) {
        nextProps[key] = settings[key];
      }
    });
    var vgpb = imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.THERMAL_IMAGE_INFO_DATA_VGPB;
    var irPaletteSetup = vgpb === null || vgpb === void 0 ? void 0 : vgpb.irPaletteSetup;
    if ("irOrientation" in nextProps) {
      nextProps.irOrientation = (0, _editor.rotationToIndex)(nextProps.irOrientation);
    }
    var updatedProps = {};
    for (var key in nextProps) {
      var value = nextProps[key];
      var isEqual = arePropsEqual(irPaletteSetup[key], value);
      if (isEqual === false) updatedProps[key] = value;
    }
    return updatedProps;
  }, [imageInfo]);
  var checkThermalImageInfo = (0, _react.useCallback)(function () {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var keys = ["capturedEmissivity", "capturedBackgroundTempC", "capturedTransmissionFactor"];
    var nextProps = {};
    keys.forEach(function (key) {
      if (key in settings) {
        nextProps[key] = settings[key];
      }
    });
    var vgpb = imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo.THERMAL_IMAGE_INFO_DATA_VGPB;
    var updatedProps = {};
    for (var key in nextProps) {
      var value = nextProps[key];
      var isEqual = arePropsEqual(vgpb[key], value);
      if (isEqual === false) updatedProps[key] = value;
    }
    return updatedProps;
  }, [imageInfo]);
  var checkIRVIEWER = (0, _react.useCallback)(function () {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var keys = ["globalMarkerVisible", "EditorNotes", "referenceMarkerId", "status"];
    var nextProps = {};
    keys.forEach(function (key) {
      if (key in settings) {
        nextProps[key] = settings[key];
      }
    });
    var irviewer = imageInfo.IRVIEWER || {};
    if ("globalMarkerVisible" in nextProps) {
      var _nextProps$globalMark;
      nextProps.globalMarkerVisible = (_nextProps$globalMark = nextProps.globalMarkerVisible) !== null && _nextProps$globalMark !== void 0 ? _nextProps$globalMark : true;
    }
    if ("EditorNotes" in nextProps) {
      nextProps.EditorNotes = nextProps.EditorNotes || [];
    }
    if ("referenceMarkerId" in nextProps) {
      var _nextProps$referenceM;
      nextProps.referenceMarkerId = (_nextProps$referenceM = nextProps.referenceMarkerId) !== null && _nextProps$referenceM !== void 0 ? _nextProps$referenceM : "";
    }
    if ("status" in nextProps) {
      nextProps.status = (0, _utilities.checkStatusObject)(nextProps.status);
    }
    var updatedProps = {};
    for (var key in nextProps) {
      var value = nextProps[key];
      var isEqual = arePropsEqual(irviewer[key], value);
      if (isEqual === false) updatedProps[key] = value;
    }
    return updatedProps;
  }, [imageInfo]);
  var checkMARKERS = (0, _react.useCallback)(function () {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var keys = ["standardMarkers"];
    var nextProps = {};
    keys.forEach(function (key) {
      if (key in settings) {
        nextProps[key] = settings[key];
      }
    });
    var updatedProps = {};
    if ("standardMarkers" in nextProps) {
      // update visibility of standard markers
      var _imageInfo$MARKERS = imageInfo.MARKERS,
        MARKERS = _imageInfo$MARKERS === void 0 ? {} : _imageInfo$MARKERS;
      var _MARKERS$STANDARD = MARKERS.STANDARD,
        STANDARD = _MARKERS$STANDARD === void 0 ? {} : _MARKERS$STANDARD;
      var _nextProps$standardMa = nextProps.standardMarkers,
        standardMarkers = _nextProps$standardMa === void 0 ? [] : _nextProps$standardMa;
      var prevProp = (0, _utilities.getVisibleStandardMarkers)(MARKERS);

      // changed props
      var addedProps = standardMarkers.filter(function (value) {
        return !prevProp.includes(value);
      });
      var removedProps = prevProp.filter(function (value) {
        return !standardMarkers.includes(value);
      });

      // update standard marker object
      var _iterator2 = _createForOfIteratorHelper(addedProps),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _STANDARD$marker, _STANDARD$marker$char;
          var marker = _step2.value;
          var markerEnabledFlag = (_STANDARD$marker = STANDARD[marker]) === null || _STANDARD$marker === void 0 ? void 0 : (_STANDARD$marker$char = _STANDARD$marker.characteristics) === null || _STANDARD$marker$char === void 0 ? void 0 : _STANDARD$marker$char.markerEnabledFlag;
          if (markerEnabledFlag === false) {
            updatedProps[marker] = STANDARD[marker];
            STANDARD[marker].characteristics.markerEnabledFlag = true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(removedProps),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _STANDARD$_marker, _STANDARD$_marker$cha;
          var _marker = _step3.value;
          var _markerEnabledFlag = (_STANDARD$_marker = STANDARD[_marker]) === null || _STANDARD$_marker === void 0 ? void 0 : (_STANDARD$_marker$cha = _STANDARD$_marker.characteristics) === null || _STANDARD$_marker$cha === void 0 ? void 0 : _STANDARD$_marker$cha.markerEnabledFlag;
          if (_markerEnabledFlag === true) {
            updatedProps[_marker] = STANDARD[_marker];
            STANDARD[_marker].characteristics.markerEnabledFlag = false;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    return updatedProps;
  }, [imageInfo]);
  var modifyImageInfo = (0, _react.useCallback)(function () {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var modifiedImageInfo = {};
    var changedKeys = [];
    var hasKeys = function hasKeys(object) {
      return Object.keys(object).length !== 0;
    };
    if (imageInfo && hasKeys(imageInfo)) {
      var basicPresentationFlags = checkBasicPresentationFlags(settings);
      var irPaletteSetup = checkIRPaletteSetup(settings);
      var vgpb = checkThermalImageInfo(settings);
      var irviewer = checkIRVIEWER(settings);
      var markers = checkMARKERS(settings);
      var modifiedVGPBProps = {};
      var modifiedIRVIEWERProps = {};
      var modifiedMARKERSProps = {};
      var allKeys = {
        basicPresentationFlags: Object.keys(basicPresentationFlags),
        irPaletteSetup: Object.keys(irPaletteSetup),
        vgpb: Object.keys(vgpb),
        irviewer: Object.keys(irviewer),
        markers: Object.keys(markers)
      };
      if (hasKeys(allKeys.basicPresentationFlags) || hasKeys(allKeys.irPaletteSetup) || hasKeys(allKeys.vgpb) || hasKeys(allKeys.irviewer) || hasKeys(allKeys.markers)) {
        var _imageInfo$IRVIEWER, _imageInfo$MARKERS2, _imageInfo$MARKERS3;
        modifiedVGPBProps = _objectSpread(_objectSpread(_objectSpread({}, imageInfo.THERMAL_IMAGE_INFO_DATA_VGPB), vgpb), {}, {
          basicPresentationFlags: _objectSpread(_objectSpread({}, imageInfo.THERMAL_IMAGE_INFO_DATA_VGPB.basicPresentationFlags), basicPresentationFlags),
          irPaletteSetup: _objectSpread(_objectSpread({}, imageInfo.THERMAL_IMAGE_INFO_DATA_VGPB.irPaletteSetup), irPaletteSetup)
        });
        modifiedIRVIEWERProps = _objectSpread(_objectSpread({}, (_imageInfo$IRVIEWER = imageInfo.IRVIEWER) !== null && _imageInfo$IRVIEWER !== void 0 ? _imageInfo$IRVIEWER : {}), irviewer);
        modifiedMARKERSProps = _objectSpread(_objectSpread({}, imageInfo.MARKERS), {}, {
          STANDARD: _objectSpread(_objectSpread({}, (_imageInfo$MARKERS2 = imageInfo.MARKERS) === null || _imageInfo$MARKERS2 === void 0 ? void 0 : _imageInfo$MARKERS2.STANDARD), (markers === null || markers === void 0 ? void 0 : markers.STANDARD) || {}),
          USERDEFINED: _objectSpread(_objectSpread({}, (_imageInfo$MARKERS3 = imageInfo.MARKERS) === null || _imageInfo$MARKERS3 === void 0 ? void 0 : _imageInfo$MARKERS3.USERDEFINED), (markers === null || markers === void 0 ? void 0 : markers.USERDEFINED) || {})
        });
        modifiedImageInfo = _objectSpread(_objectSpread({}, imageInfo), {}, {
          IRVIEWER: modifiedIRVIEWERProps,
          MARKERS: modifiedMARKERSProps,
          THERMAL_IMAGE_INFO_DATA_VGPB: modifiedVGPBProps
        });
        changedKeys = [].concat(_toConsumableArray(allKeys.basicPresentationFlags), _toConsumableArray(allKeys.irPaletteSetup), _toConsumableArray(allKeys.vgpb), _toConsumableArray(allKeys.irviewer), _toConsumableArray(allKeys.markers));
      }
    }
    return {
      modifiedImageInfo: modifiedImageInfo,
      changedKeys: changedKeys
    };
  }, [checkBasicPresentationFlags, checkIRPaletteSetup, checkIRVIEWER, checkMARKERS, checkThermalImageInfo, imageInfo]);
  return {
    imageInfo: imageInfo,
    setImageInfo: setImageInfo,
    modifyImageInfo: modifyImageInfo
  };
}